import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioUsuario from '../servicios/ServicioUsuario';
import servicioPerfil from '../servicios/ServicioPerfil';
import servicioEmisor from '../servicios/ServicioEmisor';
import servicioSucursal from '../servicios/ServicioSucursal';
 
export class AdministracionUsuarios extends Component {
    constructor() {
        super();
        this.state = {
            usuario: {},
            paginacion: {registrosPorPagina: 20},
            inicio: 0,
            erroresRequeridos: {},
            mostrarModalUsuario: false,
            perfiles: [],
            sucursales:[],
            emisores:[],
            botonEditar:false
        }

    }
    componentDidMount() {
        this.obtenerPagina();

    }
    cambiaPagina(event) {
        let { paginacion } = this.state;

        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerPagina();
    }
    obtenerPagina() {
        let { paginacion } = this.state;
        servicioUsuario.paginacion(paginacion).then((response) => {
            this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

            if (response.data.error === false)
                this.setState({ paginacion: response.data.objeto });


        }).catch((error) => {
            if (error)
                return this.growl.show({ life: 4000, severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });

    }
    editarUsuario = (rowData, column) => {

        return <div style={{display:'inline-block', justifyContent:'center'}}>
            <div className="p-col-12 p-md-4">
                <Button type="button" icon="pi-md-edit" className="p-button-success" name="xml"
                    tooltip="editar" onClick={(e) => this.editar(column.rowData)} >
                </Button>
            </div>
        </div>;
    }
    asignarValoresObjeto = (event) => {
        console.log(event.target.id);
        if (event.target.id === "usuario" ||event.target.id === "likeUsuario")
            servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
        else
            servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
    }
    editar(objeto) {
        servicioSucursal.lista_sucursales().then((response) => {
          
            if (response.data.error === false)
                this.setState({ sucursales: response.data.lista });

        }).catch((error) => {
            if (error)
                return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });

        servicioPerfil.buscaListaPerfil().then((response) => {
           
            if (response.data.error === false)
                this.setState({ perfiles: response.data.lista });

        }).catch((error) => {
            if (error)
                return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });

        servicioEmisor.buscarEmisores().then((response) => {
           
            if (response.data.error === false)
                this.setState({ emisores: response.data.lista });

        }).catch((error) => {
            if (error)
                return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });




        this.setState({ mostrarModalUsuario: true, usuario: objeto,botonEditar:true });
    }
    nuevo() {

        servicioSucursal.lista_sucursales().then((response) => {
          
            if (response.data.error === false)
                this.setState({ sucursales: response.data.lista });

        }).catch((error) => {
            if (error)
                return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });

        servicioPerfil.buscaListaPerfil().then((response) => {
          
            if (response.data.error === false)
                this.setState({ perfiles: response.data.lista });

        }).catch((error) => {
            if (error)
                return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });

        servicioEmisor.buscarEmisores().then((response) => {
           
            if (response.data.error === false)
                this.setState({ emisores: response.data.lista });

        }).catch((error) => {
            if (error)
                return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });

        this.setState({ mostrarModalUsuario: true,botonEditar:false });
    }
    guardar = () => {
        const { usuario } = this.state;
        const validacion = this.validarFormulario(usuario);
        this.setState({ erroresRequeridos: validacion });
        if (!Object.keys(validacion).length) {
            servicioUsuario.registroAdmin(usuario).then((response) => {
                this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                if (response.data.error === false)
                    this.setState({ usuario: {},mostrarModalUsuario:false,botonEditar:false});
    
            }).catch((error) => {
                if (error)
                    return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
            });
        }
    }
    
   
    validarFormulario = (usuario) => {
        const errores = {};
        var expreReg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        var validacionCorreo = expreReg.exec(usuario.usuario);

        if (!usuario.nombre)
            errores.nombre = "El nombre es requerido";
        
        if (!usuario.usuario)
            errores.correo = "El correo es requerido";
        if (!validacionCorreo)
            errores.correo = "El correo no es valido";
        if (!usuario.tcPerfil)
            errores.tcPerfil="El perfil es requerido";
        if (!usuario.telefono)
            errores.telefono="El telefono es requerido";


        return errores;
    }
    mostrarPerfil(e, fila) {
        console.log(this.state.perfiles);
        var posicion = 0;
        let daton = this.state.perfiles;
        daton.map((datoss, i) => {
            return (datoss.code === e.value.code) ? posicion = i : posicion;


        });
    }
    templatePerfil = (option) => {
        return (
            <div className="p-clearfix">
                <span >{option.nombre}</span>
            </div>
        );
    }
    templateEmisor = (option) => {
        return (
            <div className="p-clearfix">
                <span >{option.rfc}</span>
            </div>
        );
    }
    templateSucursal = (option) => {
        return (
            <div className="p-clearfix">
                <span >{option.nombre}</span>
            </div>
        );
    }
    buscarLike = (e) => {
        let { usuario, paginacion } = this.state;

        servicioUsuario.buscarlike(usuario).then((response) => {
            if (response.data.lista.length === 0) {
                this.growl.show({ life: 6000, severity: 'error', summary: '', detail: 'No existe informaci\u00f3n con los valores ingresados, verifica tus datos' });
                paginacion['datos'] = response.data.lista;
                this.setState({ valorencontrado: response.data, paginacion });
            } else {
                this.growl.show({ life: 1000, severity: 'success', summary: '', detail: "Valores encontrados" });
                paginacion['datos'] = response.data.lista;
                this.setState({ valorencontrado: response.data.lista, paginacion });
            }
        }).catch((error) => {
            if (error.status === 500)
                this.growl.show({ life: 6000, severity: 'error', summary: '', detail: 'Lo sentimos, no hay información disponible.' });
        });

    }
    columnaEstatus = (rowData, column) => {
        if (rowData.estato === 1)
            return <p>Activo</p>
        if (rowData.estato === 0)
            return <p>Desactivado</p>
     
    }

    editar_usuario = () => {
        const { usuario } = this.state;
        const validacion = this.validarFormulario(usuario);
        this.setState({ erroresRequeridos: validacion });
        if (!Object.keys(validacion).length) {
            servicioUsuario.usuario_editar_admin(usuario).then((response) => {
                this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                if (response.data.error === false)
                    this.setState({ usuario: {},mostrarModalUsuario:false,botonEditar:false});
    
            }).catch((error) => {
                if (error)
                    return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
            });
        }
    }

    cerrarModalUsuario=()=>{
        this.setState({ usuario: {}, mostrarModalUsuario: false, erroresRequeridos: {},botonEditar:false })
    }

    render() {
        const { usuario, erroresRequeridos, paginacion, inicio,botonEditar } = this.state;
        const dialogFooter = (
            <div>
               {botonEditar ? <Button icon="pi-md-check" onClick={this.editar_usuario} label="Editar" className="teal-btn flat-btn" />:<Button icon="pi-md-check" onClick={this.guardar} label="Guardar" className="teal-btn flat-btn" />} 
                <Button icon="pi-md-close" onClick={() => this.setState({ usuario: {}, mostrarModalUsuario: false, erroresRequeridos: {} })} label="Cancelar" className="p-button-danger flat-btn" />
            </div>
        );
        return (<div className="card card-w-title">
            <Growl ref={(el) => this.growl = el} />
            <h1 style={{marginBottom:'30px'}}>Administración de Usuarios</h1>
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-4">
                    <Button type="button" className="blue-grey-btn flat-btn" label="Nuevo Usuario" name="nuevo" value="Nuevo"
                        tooltip="nuevo" onClick={(e) => this.nuevo()} >
                    </Button>
                </div>
                <div className="p-col-12" style={{marginTop:'30px', fontWeight:'bold', marginLeft:'5px'}}>
                                <label htmlFor="buscar">Buscar usuario:</label>
                            </div>
                            <div className="p-col-12 p-md-6" style={{marginLeft:'5px', marginBottom:'30px'}}>
                                <InputText id="likeUsuario" className="p-inputtext" size={100} placeholder="Buscar por Nombre " name="usuario.nombre" value={usuario.nombre || ''} onChange={this.asignarValoresObjeto} onKeyUp={this.buscarLike.bind(this)} />
                            </div>
            </div>
            <Card>
                <DataTable value={paginacion.datos} editable={true} scrollable={true} scrollHeight="280px"  >
                    <Column field="nombre" header="Nombre"  style={{ width: '200px', textAlign:'center'}} filter={false} autoLayout={true} />
                    <Column field="usuario" header="Usuario"  style={{ width: '200px', textAlign:'center'}} filter={false} autoLayout={true} />
                    <Column field="estato" body={this.columnaEstatus.bind(this)} header="Estado"  style={{ width: '200px', textAlign:'center'}} filter={false} autoLayout={true} />
                    <Column field="telefono" header="Teléfono"  style={{ width: '200px', textAlign:'center'}} filter={false} autoLayout={true} />
                    <Column header="Editar" body={this.editarUsuario.bind(this)}  style={{ width: '100px', textAlign:'center'}} />
                </DataTable>
                <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
            </Card>
            <Dialog header="Usuario, los campos con * son requeridos." blockScroll visible={this.state.mostrarModalUsuario} footer={dialogFooter} onHide={this.cerrarModalUsuario}>

                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="nombre">* Nombre:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="nombre" name="usuario.nombre" value={usuario.nombre || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.nombre ? 'p-error' : ''} />
                        {erroresRequeridos.nombre ? <div> <Message severity="error" text={erroresRequeridos.nombre} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="usuario">* Correo:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="usuario" disabled={botonEditar} name="usuario.usuario" value={usuario.usuario || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.usuario ? 'p-error' : ''} />
                        {erroresRequeridos.correo ? <div> <Message severity="error" text={erroresRequeridos.correo} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="telefono">* Telefono:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="telefono" name="usuario.telefono" value={usuario.telefono || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.telefono ? 'p-error' : ''} />
                        {erroresRequeridos.telefono ? <div> <Message severity="error" text={erroresRequeridos.telefono} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="perfil">* Perfil:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <Dropdown dataKey="id" id="tcPerfil" name="usuario.tcPerfil" options={this.state.perfiles} value={usuario.tcPerfil} onChange={this.asignarValoresObjeto} placeholder="Selecciona perfil" itemTemplate={this.templatePerfil} optionLabel="nombre" className={erroresRequeridos.tcPerfil ? 'p-error' : ''} />
                        {erroresRequeridos.tcPerfil ? <div> <Message severity="error" text={erroresRequeridos.tcPerfil} /> </div> : null}
                  </div>
                  <div className="p-col-12 p-md-2">
                        <label htmlFor="emisor">* Emisor:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <Dropdown dataKey="id" id="tcEmisor" name="usuario.tcEmisor" options={this.state.emisores} value={usuario.tcEmisor} onChange={this.asignarValoresObjeto} placeholder="Selecciona emisor" itemTemplate={this.templateEmisor} optionLabel="rfc" className={erroresRequeridos.tcEmisor ? 'p-error' : ''} />
                        {erroresRequeridos.tcEmisor ? <div> <Message severity="error" text={erroresRequeridos.tcEmisor} /> </div> : null}
                  </div>
                  <div className="p-col-12 p-md-2">
                        <label htmlFor="sucursal">* Sucursal:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <Dropdown dataKey="id" id="tcSucursal" name="usuario.tcSucursal" options={this.state.sucursales} value={usuario.tcSucursal} onChange={this.asignarValoresObjeto} placeholder="Selecciona sucursal" itemTemplate={this.templateSucursal} optionLabel="nombre" className={erroresRequeridos.tcSucursal ? 'p-error' : ''} />
                        {erroresRequeridos.tcSucursal ? <div> <Message severity="error" text={erroresRequeridos.tcSucursal} /> </div> : null}
                  </div>

                </div>
            </Dialog>
        </div>


        );

    }
}